import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const buy_InvoiceApi = createAsyncThunk(
  "buy_Invoice",
  async ({ startDate = null, endDate = null }) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.get("/buy_Invoice", { params });
    return response.data;
  }
);

const buy_InvoiceSlice = createSlice({
  name: "buy_Invoice",
  initialState: {
    buy_Invoice: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(buy_InvoiceApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(buy_InvoiceApi.fulfilled, (state, action) => {
        state.buy_Invoice = action.payload;
        state.loading = false;
      })
      .addCase(buy_InvoiceApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default buy_InvoiceSlice.reducer;
